import React from "react";
import { Link, useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();
    const goToAdmin=()=>{
    navigate("/admin");
  }
  return (
    <div>
    {/* Header */}
      <header className="text-center py-6 bg-orange-400 text-white p-6 m-0">
        <h1 className="text-4xl font-bold">Bio-Produkte aus Sizilien</h1>
        <p className="mt-2 text-md">Orangen, Mandarinen, Zitronen und Olivenöl direkt vom Feld</p>
      </header>
      <div className="w-full h-56 bg-cover bg-center" style={{ backgroundImage: `url(${require('./images/bioorangen14.jpg')})` }}></div>
    <div className="block mx-auto w-max p-6 py-3">
      <div className="bg-white p-10 text-center max-w-md w-full">

        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-gray-700 text-lg mb-6">
          Die Seite, die du suchst, wurde nicht gefunden.
        </p>

        <Link 
          to="/" 
          className="inline-block bg-orange-600 hover:bg-orange-700 text-white font-semibold px-6 py-3 rounded-xl transition"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
    {/* Footer */}
      <footer className="text-center py-8">
        © <a onClick={goToAdmin} >BioOrangen.ch </a> | Rietrasse 28, 8733 Eschenbach
      </footer>
    </div>
  );
};

export default NotFound;
